import { type EditorSection } from '@/lib/types';
import { createContext } from 'react';

type SectionContextValue = {
  section: EditorSection;
  previousSection: EditorSection | null;
  nextSection: EditorSection | null;
};

const SectionContext = createContext<SectionContextValue>({
  section: null as unknown as EditorSection,
  previousSection: null,
  nextSection: null,
});

export default SectionContext;
